export const transitRoutes = [
  {
    id: 1,
    number: '1',
    name: 'Downtown Connector',
    color: '#3B82F6',
    description: 'Connects downtown Roseville to major shopping centers and transit hubs',
    schedule: 'Mon-Fri: 6:00 AM - 8:00 PM | Sat: 8:00 AM - 6:00 PM | Sun: Closed',
    frequency: 'Every 30 minutes',
    stops: [
      'Downtown Transit Center',
      'City Hall',
      'Roseville Square',
      'Galleria Mall',
      'Kaiser Permanente',
      'Westfield Mall',
      'Sierra College'
    ]
  },
  {
    id: 2,
    number: '2',
    name: 'East-West Express',
    color: '#10B981',
    description: 'Fast route connecting east and west Roseville neighborhoods',
    schedule: 'Mon-Fri: 5:30 AM - 9:00 PM | Sat-Sun: 7:00 AM - 7:00 PM',
    frequency: 'Every 20 minutes',
    stops: [
      'West Roseville Park & Ride',
      'Pleasant Grove Blvd',
      'Woodcreek Oaks',
      'Douglas Blvd',
      'Sunrise Mall',
      'Cirby Way',
      'East Roseville Station'
    ]
  },
  {
    id: 3,
    number: '3',
    name: 'Medical Center Loop',
    color: '#EF4444',
    description: 'Serves medical facilities, senior centers, and residential areas',
    schedule: 'Mon-Fri: 7:00 AM - 6:00 PM | Sat: 9:00 AM - 5:00 PM | Sun: Closed',
    frequency: 'Every 45 minutes',
    stops: [
      'Sutter Roseville Medical Center',
      'Kaiser Permanente',
      'Senior Center',
      'Library',
      'Community Center',
      'Maidu Park'
    ]
  },
  {
    id: 4,
    number: '4',
    name: 'College Commuter',
    color: '#F59E0B',
    description: 'Direct service to Sierra College and surrounding student housing',
    schedule: 'Mon-Fri: 6:00 AM - 10:00 PM | Sat: 8:00 AM - 8:00 PM | Sun: 10:00 AM - 6:00 PM',
    frequency: 'Every 15 minutes (peak) / 30 minutes (off-peak)',
    stops: [
      'Sierra College Campus',
      'Student Housing Complex',
      'Rocklin Station',
      'Downtown Transit Center',
      'Library',
      'Galleria Mall'
    ]
  },
  {
    id: 5,
    number: '5',
    name: 'North-South Corridor',
    color: '#8B5CF6',
    description: 'Connects northern and southern neighborhoods with key destinations',
    schedule: 'Mon-Sat: 6:30 AM - 8:30 PM | Sun: 9:00 AM - 6:00 PM',
    frequency: 'Every 40 minutes',
    stops: [
      'North Roseville Park & Ride',
      'Blue Oaks Blvd',
      'Westfield Mall',
      'Downtown Transit Center',
      'Riverside Gateway',
      'South Roseville Station'
    ]
  },
  {
    id: 6,
    number: '6',
    name: 'Shopping District Shuttle',
    color: '#EC4899',
    description: 'Frequent stops at major retail centers and dining districts',
    schedule: 'Mon-Sat: 9:00 AM - 9:00 PM | Sun: 10:00 AM - 7:00 PM',
    frequency: 'Every 25 minutes',
    stops: [
      'Westfield Galleria',
      'Roseville Square',
      'The Fountains',
      'Stoneridge Shopping Center',
      'Downtown Dining District',
      'Mahany Park'
    ]
  }
];

export const fares = [
  {
    type: 'Single Ride',
    price: '$2.00',
    description: 'Valid for one trip, any route',
    icon: 'ri-ticket-line'
  },
  {
    type: 'Day Pass',
    price: '$5.00',
    description: 'Unlimited rides for 24 hours',
    icon: 'ri-calendar-line'
  },
  {
    type: 'Weekly Pass',
    price: '$20.00',
    description: 'Unlimited rides for 7 days',
    icon: 'ri-calendar-check-line'
  },
  {
    type: 'Monthly Pass',
    price: '$65.00',
    description: 'Unlimited rides for 30 days',
    icon: 'ri-calendar-2-line'
  },
  {
    type: 'Senior/Disabled',
    price: '$1.00',
    description: 'Reduced fare with valid ID',
    icon: 'ri-user-heart-line'
  },
  {
    type: 'Youth (6-18)',
    price: '$1.50',
    description: 'Discounted fare for students',
    icon: 'ri-user-smile-line'
  },
  {
    type: 'Children (Under 6)',
    price: 'FREE',
    description: 'Free with paying adult',
    icon: 'ri-user-star-line'
  }
];

export const rideshareOptions = [
  {
    id: 1,
    name: 'Uber',
    icon: 'ri-taxi-line',
    description:
      'On-demand rides available 24/7 throughout Roseville and surrounding areas',
    avgWait: '3-8 min',
    priceRange: '$8 - $25',
    features: ['UberX', 'UberXL', 'Uber Comfort', 'Uber Pet'],
    link: 'https://www.uber.com'
  },
  {
    id: 2,
    name: 'Lyft',
    icon: 'ri-taxi-wifi-line',
    description:
      'Affordable rideshare with options for every group size and budget',
    avgWait: '4-10 min',
    priceRange: '$7 - $22',
    features: ['Lyft Standard', 'Lyft XL', 'Lyft Lux', 'Wait & Save'],
    link: 'https://www.lyft.com'
  },
  {
    id: 3,
    name: 'Yellow Cab Roseville',
    icon: 'ri-roadster-line',
    description:
      'Traditional taxi service with metered fares and advance booking',
    avgWait: '10-20 min',
    priceRange: '$10 - $35',
    features: [
      'Airport Runs',
      'Advance Booking',
      'Wheelchair Accessible',
      'Corporate Accounts'
    ],
    link: 'tel:9167831234'
  }
];

export const bikingTrails = [
  {
    id: 1,
    name: 'Miners Ravine Trail',
    distance: '5.5 miles',
    difficulty: 'Easy',
    surface: 'Paved',
    description:
      'Scenic paved trail following historic mining route through oak woodlands and creek crossings',
    highlights: ['Creek Views', 'Wildlife', 'Shaded Sections', 'Historic Markers'],
    trailhead: 'Miners Ravine Trailhead, Sierra College Blvd'
  },
  {
    id: 2,
    name: 'Dry Creek Greenway',
    distance: '4.2 miles',
    difficulty: 'Easy',
    surface: 'Paved',
    description:
      'Popular multi-use path connecting neighborhoods to parks and shopping areas',
    highlights: ['Park Access', 'Flat Terrain', 'Family Friendly', 'Rest Stops'],
    trailhead: 'Mahany Park, 1545 Pleasant Grove Blvd'
  },
  {
    id: 3,
    name: 'Oak Ridge Trail',
    distance: '3.8 miles',
    difficulty: 'Moderate',
    surface: 'Mixed',
    description:
      'Rolling terrain through oak groves with some unpaved sections for mountain biking',
    highlights: ['Oak Groves', 'Hill Climbs', 'Nature Views', 'MTB Friendly'],
    trailhead: 'Maidu Regional Park, 1550 Maidu Dr'
  },
  {
    id: 4,
    name: 'Pleasant Grove Creek Trail',
    distance: '6.1 miles',
    difficulty: 'Easy',
    surface: 'Paved',
    description:
      'Long paved corridor ideal for commuters and recreational cyclists alike',
    highlights: ['Commuter Route', 'Well Maintained', 'Lighting', 'Benches'],
    trailhead: 'Woodcreek Oaks Blvd & Pleasant Grove Blvd'
  }
];

export const airportConnections = [
  {
    id: 1,
    name: 'Sacramento International Airport (SMF)',
    distance: '18 miles',
    driveTime: '25-35 min',
    icon: 'ri-flight-takeoff-line',
    options: [
      {
        mode: 'Drive & Park',
        detail: 'Long-term parking from $10/day, short-term $3/hr',
        icon: 'ri-car-line'
      },
      {
        mode: 'Rideshare',
        detail: 'Uber/Lyft pickup at Terminal A & B ground level',
        icon: 'ri-taxi-line'
      },
      {
        mode: 'Airport Shuttle',
        detail: 'SuperShuttle and private services available',
        icon: 'ri-bus-2-line'
      },
      {
        mode: 'Yolobus Route 42',
        detail: 'Public transit option via Sacramento, $2.75 fare',
        icon: 'ri-route-line'
      }
    ]
  },
  {
    id: 2,
    name: 'Sacramento Valley Station (Amtrak)',
    distance: '22 miles',
    driveTime: '30-40 min',
    icon: 'ri-train-line',
    options: [
      {
        mode: 'Capitol Corridor',
        detail: 'Service to Bay Area, Auburn, and beyond',
        icon: 'ri-train-line'
      },
      {
        mode: 'Roseville Commuter',
        detail: 'Express bus to Sacramento Valley Station',
        icon: 'ri-bus-2-line'
      },
      {
        mode: 'Amtrak Thruway',
        detail: 'Bus connections to Reno, Lake Tahoe, and more',
        icon: 'ri-bus-line'
      },
      {
        mode: 'Drive & Park',
        detail: 'Parking garage adjacent to station, $8/day',
        icon: 'ri-car-line'
      }
    ]
  }
];

export const safetyTips = [
  {
    icon: 'ri-shield-check-line',
    title: 'Ride Safely',
    description: 'Always verify your driver and vehicle before entering a rideshare'
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Be Visible',
    description:
      'Wear reflective gear and use lights when cycling at dawn, dusk, or night'
  },
  {
    icon: 'ri-smartphone-line',
    title: 'Stay Connected',
    description:
      'Share your trip details with a friend or family member when traveling'
  },
  {
    icon: 'ri-road-map-line',
    title: 'Plan Ahead',
    description:
      'Check transit schedules and road conditions before heading out'
  }
];

export const quickFacts = [
  { label: 'Transit Routes', value: '6', icon: 'ri-bus-2-line' },
  { label: 'Miles of Bike Trails', value: '45+', icon: 'ri-bike-line' },
  { label: 'Free Parking Lots', value: '12', icon: 'ri-parking-box-line' },
  { label: 'EV Chargers', value: '50+', icon: 'ri-charging-pile-2-line' }
];

export const parkingLocations = [
  {
    id: 1,
    name: 'Downtown Transit Center Parking',
    address: '300 Main St, Roseville, CA 95678',
    spaces: 250,
    rate: 'FREE',
    hours: '24/7',
    features: ['EV Charging', 'Bike Racks', 'Security Cameras', 'Well Lit'],
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=Downtown+Transit+Center+Roseville+CA'
  },
  {
    id: 2,
    name: 'Westfield Galleria Parking',
    address: '1151 Galleria Blvd, Roseville, CA 95678',
    spaces: 1200,
    rate: 'FREE (3 hrs), $2/hr after',
    hours: 'Mon-Sat: 10 AM - 9 PM, Sun: 11 AM - 7 PM',
    features: ['Covered Parking', 'EV Charging', 'Valet Service', 'Handicap Access'],
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=Westfield+Galleria+Roseville+CA'
  },
  {
    id: 3,
    name: 'Vernon Street Garage',
    address: '227 Vernon St, Roseville, CA 95678',
    spaces: 180,
    rate: '$1/hr, $8 daily max',
    hours: '24/7',
    features: ['Covered', 'Monthly Passes', 'Security Patrol', 'Elevator Access'],
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=Vernon+Street+Garage+Roseville+CA'
  },
  {
    id: 4,
    name: 'Mahany Park Lot',
    address: '1545 Pleasant Grove Blvd, Roseville, CA 95747',
    spaces: 320,
    rate: 'FREE',
    hours: '6 AM - 10 PM',
    features: ['Bike Racks', 'Picnic Areas', 'Restrooms', 'Trail Access'],
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=Mahany+Park+Roseville+CA'
  },
  {
    id: 5,
    name: 'Sierra College Parking Structure',
    address: '5000 Rocklin Rd, Rocklin, CA 95677',
    spaces: 450,
    rate: '$3/day (students), $5/day (visitors)',
    hours: '24/7',
    features: ['Student Permits', 'EV Charging', 'Covered Levels', 'Campus Access'],
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=Sierra+College+Rocklin+CA'
  },
  {
    id: 6,
    name: 'Roseville Square Parking',
    address: '1117 Roseville Square, Roseville, CA 95678',
    spaces: 280,
    rate: 'FREE',
    hours: '24/7',
    features: ['Shopping Access', 'Restaurant Parking', 'Bike Racks', 'Well Lit'],
    mapUrl: 'https://www.google.com/maps/search/?api=1&query=Roseville+Square+Roseville+CA'
  }
];
